import React from "react";

const Status = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 8 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.23996 0.803467H0.682592C0.50868 0.803467 0.341891 0.872553 0.218916 0.995528C0.0959418 1.1185 0.0268555 1.28529 0.0268555 1.4592V8.01657C0.0268555 8.19048 0.0959418 8.35727 0.218916 8.48025C0.341891 8.60322 0.50868 8.67231 0.682592 8.67231H7.23996C7.41387 8.67231 7.58066 8.60322 7.70364 8.48025C7.82661 8.35727 7.8957 8.19048 7.8957 8.01657V1.4592C7.8957 1.28529 7.82661 1.1185 7.70364 0.995528C7.58066 0.872553 7.41387 0.803467 7.23996 0.803467V0.803467ZM5.98996 3.99199L3.58833 6.28707C3.52624 6.34547 3.44406 6.37776 3.35882 6.37723C3.27483 6.37755 3.19401 6.34522 3.13341 6.28707L1.93259 5.13953C1.89928 5.11047 1.8722 5.07498 1.85296 5.03518C1.83372 4.99539 1.82272 4.95212 1.82064 4.90796C1.81855 4.86381 1.82541 4.81969 1.8408 4.77826C1.8562 4.73683 1.87981 4.69894 1.91023 4.66687C1.94064 4.63479 1.97723 4.6092 2.01778 4.59163C2.05834 4.57405 2.10203 4.56486 2.14623 4.56461C2.19043 4.56435 2.23423 4.57303 2.27499 4.59013C2.31575 4.60723 2.35263 4.6324 2.38341 4.66412L3.35882 5.59444L5.53914 3.51658C5.60289 3.46096 5.68568 3.43214 5.77019 3.43613C5.85469 3.44013 5.93438 3.47664 5.9926 3.53803C6.05081 3.59942 6.08304 3.68094 6.08255 3.76554C6.08206 3.85014 6.04889 3.93128 5.98996 3.99199Z"
        fill="#AEB9E1"
      />
    </svg>
  );
};

export default Status;
